export function trackAnalytics(_ref) {
  let {
    wixCodeApi,
    eventId,
    payload
  } = _ref;
  const isEditor = wixCodeApi.window.viewMode.toLowerCase() === 'editor';
  try {
    if (!isEditor) {
      wixCodeApi.window.trackEvent(eventId, payload);
    }
  } catch (e) {
    console.log(e);
  }
}
//# sourceMappingURL=trackAnalytics.js.map